module.exports = __webpack_public_path__ + "img/gs.6a287b75.png";